/* global jQuery */
( ( $ ) => {
    
     /*check if element is in viewport*/
    $.fn.isInViewport = function () {
    const elementTop = $(this).offset().top;
    const elementBottom = elementTop + $(this).outerHeight();
    const viewportTop = $(window).scrollTop();
    const viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  };
    
 //       function elementScrolled(elem)
//  {
//    var docViewTop = $(window).scrollTop();
//    var docViewBottom = docViewTop + $(window).height();
//    var elemTop = $(elem).offset().top;
//    return ((elemTop <= docViewBottom) && (elemTop >= docViewTop));
//  }
    
	const initializeBlock = () => {

        
        const $id = $( '.patient-journey' );
        $( '.top-nav li:first-child .button' ).css('background-color', $id.data('icon-hover-color'));
        $( '.top-nav li:first-child p' ).addClass('active');
        
        $( '.top-nav li' ).attr( 'aria-selected', 'false' );
        $( '.top-nav li:first-child' ).attr( 'aria-selected', 'true' );

        $( '.top-nav li' ).attr( 'tabindex', '0' );
        
		$( '.phr-slider-content' ).not( '.slick-initialized' ).slick( {
			dots: false,
			autoplay: false,
            autoplaySpeed: 10000,
			speed: 300,
            arrows: false,
			fade: true,
            infinite: false,
			waitForAnimate: false,
            adaptiveHeight: false,
            draggable: false,
            swipe: false,
            responsive: [
				{
					breakpoint: 1200,
					settings: {
						adaptiveHeight: false,
                        draggable: false,
                        swipe: false,
                        autoplay: false,
                        autoplaySpeed: 10000,
					},
				},

				{
					breakpoint: 768,
					settings: {
                        adaptiveHeight: true,
                        draggable: false,
                        swipe: false,
                        autoplay: false,
                        autoplaySpeed: 10000,
					},
				},
                
			],
		} );

        //For Play/Pause button on GIFs
        const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce))");
        const details = document.querySelector(".pj-image-gif > details");
        
        if (mediaQuery.matches) {
            details.removeAttribute("open");
        }
                

        $( '.pj-image-gif' ).attr( 'tabindex', '0' );

        $('.pj-image-gif').each((_index, element) => {
            const $element = $(element);

            $element.on( 'keydown', ( event ) => {
                if ( (event.type === 'keydown' && event.key === 'Enter') ) {
                    event.preventDefault();
                    const currentGif = $( event.currentTarget ).children('details');

                    currentGif.prop('open', !currentGif.prop('open'));
                }
            });
        });

        
        /*START AUTOPLAY WHEN SLIDER CONTENT SCROLL INTO VIEW*/
        $(window).on('resize scroll', () => {
            
             if ($( '.phr-slider-content' ).isInViewport()) {
            $( '.phr-slider-content' ).slick('slickSetOption', 'autoplay', true);
                 $( '.phr-slider-content' ).slick( 'slickPlay' );
        }
        });
        
        
        $( '.top-nav li' ).on( 'mouseenter keydown', ( event ) => {

            if (event.type === 'mouseenter' || (event.type === 'keydown' && event.key === 'Enter')) {
                event.preventDefault();
            
            const thisButton = $( event.currentTarget).children(".button");
            const thisText = $( event.currentTarget).children("p");
             

            $( '.top-nav .button' ).css('background-color', $id.data('icon-color'));
            $( '.top-nav p' ).removeClass('active');
            $( '.top-nav li' ).attr( 'aria-selected', 'false' );
            thisButton.css('background-color', $id.data('icon-hover-color'));
            thisText.addClass('active');
            $( event.currentTarget).attr( 'aria-selected', 'true' );
			const whichslide = thisButton.data( 'slide' );

			$( '.phr-slider-content' ).slick( 'slickPause' );
			$( '.phr-slider-content' ).slick( 'slickGoTo', whichslide );

            
        
            
            
            const GAslide = ' Button - ' + (whichslide+1); 
            
            ga( 'send', 'event', 'Patient Journey Click', GAslide, document.title );
            
            window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'component_click',
                        'event_category': 'Patient Journey Click',
                        'event_label': GAslide,
                        'page_url': document.title
});
                    return false;
}
            
		} ).on( 'mouseleave', () => {
            
			$( '.phr-slider-content' ).slick( 'slickPlay' );
/*			$( '.phr-slider-content' ).slick( 'slickSetOption', 'autoplayspeed', 5000, false );*/
            
		} );

        
        $(".phr-slider-content").on("afterChange", function (){   
            

            //Accessibility fix so slide content stays in focus when using arrow keys to navigate
            if ($('.phr-slider-content .slick-slide:focus-within').length > 0) {
                setTimeout(function() { 
                    $(".phr-slider-content .slick-active").focus();
                }, 500);
            }
            
            $( '.top-nav .button' ).each(function(){
                
                const datavalue= $(this).data( 'slide' );
                const currentSlide = $('.phr-slider-content').slick('slickCurrentSlide');
                const currentTab = currentSlide;
            
                if (datavalue == currentTab){
                    $(this).css('background-color', $id.data('icon-hover-color'));
                    $(this).next().addClass('active');
                    $(this).parent().attr( 'aria-selected', 'true' );
                }
                
                else {
                    $(this).css('background-color', $id.data('icon-color'));
                    $(this).next().removeClass('active');
                    $(this).parent().attr( 'aria-selected', 'false' );
                }
                    
                
            });
                    
                    
        });
        

	};
    

	// Initialize each block on page load (front end).
	$( document ).ready( () => {
		initializeBlock();

	} );

	// Initialize dynamic block preview (editor).
	if ( window.acf ) {
		window.acf.addAction( 'render_block_preview/type=patient-journey', initializeBlock );
	}
} )( jQuery );
